import styled from 'styled-components'

export const TextareaCounter = ({
  value,
  maxLength,
}: {
  value?: string | number
  maxLength?: number
}) => {
  const charCount = String(value).length

  if (maxLength) {
    return <Root>{`${charCount}/${maxLength}`}</Root>
  }

  return <Root>{charCount > 0 ? charCount : undefined}</Root>
}

const Root = styled.div`
  margin-left: auto;
  display: flex;
  pointer-events: none;
  align-items: flex-end;
`
